"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoProductsFoundWrapper = exports.NoProductsFound = exports.iconStyle = exports.cardStyles = exports.TitleSection = exports.Divider = exports.ListItem = exports.ProductList = exports.ProductListContainer = exports.ContentWrapper = void 0;
const styles_1 = require("@mui/material/styles");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
exports.ContentWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    flexDirection: "column",
    maxHeight: "282px",
    justifyContent: "center",
});
exports.ProductListContainer = (0, styles_1.styled)("div")({
    marginTop: "24px",
    display: "flex",
    flexDirection: "column",
});
exports.ProductList = (0, styles_1.styled)("ul")({
    listStyleType: "none",
    padding: 0,
    margin: "8px 0",
});
exports.ListItem = (0, styles_1.styled)("li")({
    fontSize: 14,
});
exports.Divider = (0, styles_1.styled)("hr")({
    borderTop: "1px solid #F2F2F2;",
});
exports.TitleSection = (0, styles_1.styled)("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
exports.cardStyles = {
    maxWidth: "256px",
    maxHeight: "282px",
};
exports.iconStyle = {
    color: "#BDBDBD",
};
exports.NoProductsFound = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.grayScale.gray2,
    fontWeight: "bold"
}));
exports.NoProductsFoundWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "90px",
});
